// table-column — wireframe skin module (RUN-407: native table redesign)
// Column is projected into native <th> via manual slot assignment.
// role="columnheader" and sort indicators rendered by run-table's skin.

export const styles = `
  :host {
    display: contents;
  }
`;

export function render(host) {
  host.shadowRoot.innerHTML = `<slot></slot>`;
}
